var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDashboardOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dashboard_Icon",
    "data-name": "Dashboard Icon",
    d: "M7.841.5H1.371A.871.871,0,0,0,.5,1.371v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871V1.371A.871.871,0,0,0,7.841.5ZM6.97,6.97H2.242V2.242H6.97V6.97ZM17.629.5h-6.47a.871.871,0,0,0-.871.871v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871V1.371A.871.871,0,0,0,17.629.5Zm-.871,6.47H12.03V2.242h4.728ZM7.841,10.288H1.371a.871.871,0,0,0-.871.871v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871v-6.47A.871.871,0,0,0,7.841,10.288Zm-.871,6.47H2.242V12.03H6.97v4.728Zm10.659-6.47h-6.47a.871.871,0,0,0-.871.871v6.47a.871.871,0,0,0,.871.871h6.47a.871.871,0,0,0,.871-.871v-6.47A.871.871,0,0,0,17.629,10.288Zm-.871,6.47H12.03V12.03h4.728Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#a2a3a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboardOut);
export default __webpack_public_path__ + "static/media/menu_dashboard_out.6594ca2d83552addecb11146031e0c0b.svg";
export { ForwardRef as ReactComponent };